import { useTranslation } from 'react-i18next'
import Tooltip from '~/components/Tooltip'
import { PriceImpactLevel, useSpotSwapPriceImpact } from '~/state/dex/hooks'

const priceImpactTextColor = {
  [PriceImpactLevel.POSITIVE]: '#3AC073',
  [PriceImpactLevel.WARN]: '#6F7390',
  [PriceImpactLevel.DANGER]: '#D66665',
}

const PriceImpact: React.FC = () => {
  const { t } = useTranslation()
  const priceImpactInfo = useSpotSwapPriceImpact()
  if (priceImpactInfo?.level === PriceImpactLevel.NORMAL) {
    return null
  }

  // Negative numbers have a minus sign
  const prefixText =
    priceImpactInfo?.level === PriceImpactLevel.POSITIVE ? '+' : ''

  return (
    <Tooltip
      placement="right"
      trigger="hover"
      title={
        <span style={{ fontSize: 12 }}>
          {t('spotswap_swap_price_impact_tooltip')}
        </span>
      }
    >
      <span
        style={{
          color: priceImpactTextColor[priceImpactInfo?.level],
        }}
      >
        {` ( ${prefixText}${priceImpactInfo?.priceImpactInPercent}% )`}
      </span>
    </Tooltip>
  )
}

export default PriceImpact
